import { render, staticRenderFns } from "./StageContract.vue?vue&type=template&id=049ee5ce"
import script from "./StageContract.vue?vue&type=script&lang=ts"
export * from "./StageContract.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports